import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared.module';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { AppPreloader } from 'src/app/app-routing-loader';
import { PostLoginAuthGuard } from 'src/app/components/layout/guard/post-login-auth.guard';

// layouts & notfound
import { LayoutAuthComponent } from 'src/app/layouts/Auth/auth.component';
import { LayoutAppComponent } from 'src/app/layouts/App/app.component';
import { NotFoundComponent } from 'src/app/pages/404.component';
import { LayoutSettingComponent } from './layouts/Setting/setting.component';

const COMPONENTS = [NotFoundComponent];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    canActivate: [PostLoginAuthGuard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'auth',
    component: LayoutAuthComponent,
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/auth/auth.module#AuthModule',
      },
    ],
  },
  {
    path: 'dashboard',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/dashboard/dashboard.module#DashboardModule',
      },
    ],
  },
  {
    path: 'wallet',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/wallet/wallet.module#WalletModule',
      },
    ],
  },
  {
    path: 'network',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/agent/agent.module#AgentModule',
      },
    ],
  },
  {
    path: 'commissions',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/commission/commission.module#CommissionModule',
      },
    ],
  },
  {
    path: 'payments',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/payment/payment.module#PaymentModule',
      },
    ],
  },
  {
    path: 'user',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/user/user.module#UserModule',
      },
    ],
  },
  {
    path: 'settings',
    component: LayoutSettingComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/settings/settings.module#SettingsModule',
      },
    ],
  },
  {
    path: 'work-templates',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/work-template/work-template.module#WorkTemplateModule',
      },
    ],
  },
  {
    path: 'public',
    component: LayoutAuthComponent,
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/public-work/public-work.module#PublicWorkModule',
      },
    ],
  },
  {
    path: 'workspace',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/workspace/workspace.module#WorkspaceModule',
      },
    ],
  },
  {
    path: 'public',
    component: LayoutAuthComponent,
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/public-work/public-work.module#PublicWorkModule',
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { title: '404 - Page not found' },
  },
];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      // useHash: true,
      onSameUrlNavigation: 'reload',
      preloadingStrategy: AppPreloader,
    }),
    LayoutsModule,
  ],
  providers: [AppPreloader],
  declarations: [...COMPONENTS],
  exports: [RouterModule],
})
export class AppRoutingModule {}
